import { faBarcodeRead } from '@fortawesome/pro-regular-svg-icons/faBarcodeRead';
import { faBell } from '@fortawesome/pro-regular-svg-icons/faBell';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar';
import { faClipboardCheck } from '@fortawesome/pro-regular-svg-icons/faClipboardCheck';
import { faListCheck } from '@fortawesome/pro-regular-svg-icons/faListCheck';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { sortByDates } from 'utils/sort-by-dates';
import { DOCUMENTATION_AGENTS_MESH, MIGRATION_AGENTS_MESH, NITRO_ANALYSTS_MESH, NITRO_BREWS_MESH, RM_AGENTS_MESH, WORKFORCE_AGENTS_MESH } from './nitro-claw-mesh.config';
export const ROUTE_BASE = `/${ROUTE_PATHS.NITRO_CLAW}`;
export const RESERVED_SEGMENTS = new Set([
    'for-review',
    'notifications',
    'projects',
    'meetings',
    'tasks',
    'agents'
]);
export const isNitroClawAgentItemVisible = (id, flags)=>{
    switch(id){
        case 'nitro-analysts':
            return flags.nitroAnalyst;
        case 'migration':
            return flags.migrationAgent;
        case 'workforce':
            return flags.workforceAgent;
        case 'rm':
            return flags.rmAgent;
        case 'documentation':
            return flags.documentationAgent;
        case 'nitro-brews':
            return flags.autopilotAgent;
        default:
            {
                const exhaustive = id;
                return exhaustive;
            }
    }
};
const AGENT_BUILDER_BASE = `/${ROUTE_PATHS.AGENT_BUILDER}`;
export const AI_ANALYTICS_ROUTE_BASE = `/${ROUTE_PATHS.AI_ANALYTICS}`;
export const MIGRATION_AGENTS_ROUTE_BASE = `/${ROUTE_PATHS.MIGRATION_AGENTS}`;
const RM_AGENT_PATH = '/agents/rm';
const RM_COPILOT_PATH = `/${ROUTE_PATHS.RESOURCE_MANAGEMENT}/${ROUTE_PATHS.RM_COPILOT}`;
const NITRO_BREW_PATH = `/${ROUTE_PATHS.NITRO_BREW}`;
const NITRO_BREW_BUILDER_PATH = `${AGENT_BUILDER_BASE}/${ROUTE_PATHS.NITRO_BREW}`;
export const NITRO_BREW_RECENT_LIMIT = 5;
/** Query flag: open brew preview and auto-start an autopilot run. */ export const NITRO_BREW_AUTO_RUN_QUERY = 'run';
export const nitroBrewEditPath = (brewId)=>`${NITRO_BREW_BUILDER_PATH}/${brewId}/edit`;
export const nitroBrewRunPath = (brewId)=>`${nitroBrewEditPath(brewId)}?${NITRO_BREW_AUTO_RUN_QUERY}=1`;
export const toNitroBrewSubItems = (agents)=>[
        ...agents
    ].filter((agent)=>!agent.is_deleted && agent.is_enabled).sort((a, b)=>sortByDates(b.updated_at, a.updated_at, 'milliseconds')).slice(0, NITRO_BREW_RECENT_LIMIT).map((agent)=>({
            id: String(agent.id),
            label: agent.name,
            path: nitroBrewEditPath(agent.id),
            mesh: {
                colors: NITRO_BREWS_MESH.colors,
                meshId: agent.id
            }
        }));
const pathMatchesPrefix = (pathname, prefix)=>pathname === prefix || pathname.startsWith(`${prefix}/`);
export const AGENT_ITEMS = [
    {
        id: 'nitro-analysts',
        labelKey: 'nitro_claw.sidebar.agents.nitro_analysts',
        defaultMessage: 'Nitro Analysts',
        mesh: NITRO_ANALYSTS_MESH,
        path: AI_ANALYTICS_ROUTE_BASE,
        match: (pathname)=>pathMatchesPrefix(pathname, AI_ANALYTICS_ROUTE_BASE)
    },
    {
        id: 'migration',
        labelKey: 'nitro_claw.sidebar.agents.migration',
        defaultMessage: 'Migration Agents',
        mesh: MIGRATION_AGENTS_MESH,
        path: MIGRATION_AGENTS_ROUTE_BASE,
        match: (pathname)=>pathMatchesPrefix(pathname, MIGRATION_AGENTS_ROUTE_BASE) || pathMatchesPrefix(pathname, `${AGENT_BUILDER_BASE}/migration-agents`)
    },
    {
        id: 'workforce',
        labelKey: 'nitro_claw.sidebar.agents.workforce',
        defaultMessage: 'Workforce Agents',
        mesh: WORKFORCE_AGENTS_MESH,
        path: `${AGENT_BUILDER_BASE}/workforce-agents`,
        match: (pathname)=>pathMatchesPrefix(pathname, `${AGENT_BUILDER_BASE}/workforce-agents`)
    },
    {
        id: 'rm',
        labelKey: 'nitro_claw.sidebar.agents.rm',
        defaultMessage: 'RM Agents',
        mesh: RM_AGENTS_MESH,
        path: RM_AGENT_PATH,
        match: (pathname)=>pathMatchesPrefix(pathname, RM_AGENT_PATH) || pathMatchesPrefix(pathname, RM_COPILOT_PATH)
    },
    {
        id: 'documentation',
        labelKey: 'nitro_claw.sidebar.agents.documentation',
        defaultMessage: 'Documentation',
        mesh: DOCUMENTATION_AGENTS_MESH,
        path: `${AGENT_BUILDER_BASE}/document-agent-claw`,
        match: (pathname)=>pathMatchesPrefix(pathname, `${AGENT_BUILDER_BASE}/document-agent-claw`) || pathMatchesPrefix(pathname, `${AGENT_BUILDER_BASE}/documentation-agents`) || pathMatchesPrefix(pathname, `${AGENT_BUILDER_BASE}/documentation`)
    },
    {
        id: 'nitro-brews',
        labelKey: 'nitro_claw.sidebar.agents.nitro_brews',
        defaultMessage: 'Nitro Brews',
        mesh: NITRO_BREWS_MESH,
        path: NITRO_BREW_PATH,
        match: (pathname)=>pathMatchesPrefix(pathname, NITRO_BREW_PATH) || pathMatchesPrefix(pathname, NITRO_BREW_BUILDER_PATH),
        actions: [
            {
                id: 'new',
                labelKey: 'nitro_claw.sidebar.agents.nitro_brews.new',
                defaultMessage: 'New brew',
                path: `${NITRO_BREW_BUILDER_PATH}/create?nc=1`,
                icon: faPlus
            }
        ]
    }
];
export const getVisibleNitroClawAgentItems = (flags)=>AGENT_ITEMS.filter((item)=>isNitroClawAgentItemVisible(item.id, flags));
export const pathEndsWith = (pathname, segment)=>pathname === `${ROUTE_BASE}/${segment}` || pathname.startsWith(`${ROUTE_BASE}/${segment}/`);
export const buildPrimaryNavItems = (pending, forReviewPending)=>[
        {
            id: 'for-review',
            labelKey: 'nitro_claw.sidebar.for_review',
            defaultMessage: 'For Review',
            icon: faBarcodeRead,
            path: `${ROUTE_BASE}/for-review`,
            match: (path)=>pathEndsWith(path, 'for-review'),
            badge: forReviewPending > 0 ? forReviewPending : undefined
        },
        {
            id: 'notifications',
            labelKey: 'nitro_claw.sidebar.notifications',
            defaultMessage: 'Notifications',
            icon: faBell,
            path: `${ROUTE_BASE}/notifications`,
            match: (path)=>pathEndsWith(path, 'notifications'),
            badge: pending > 0 ? pending : undefined
        }
    ];
export const RESOURCE_NAV_ITEMS = [
    {
        id: 'projects',
        labelKey: 'nitro_claw.sidebar.resources.projects',
        defaultMessage: 'Projects',
        icon: faClipboardCheck,
        path: `${ROUTE_BASE}/projects`,
        match: (path)=>pathEndsWith(path, 'projects') || pathMatchesPrefix(path, `/${ROUTE_PATHS.PROJECTS}`)
    },
    {
        id: 'meetings',
        labelKey: 'nitro_claw.sidebar.resources.meetings',
        defaultMessage: 'Meetings',
        icon: faCalendar,
        path: `${ROUTE_BASE}/meetings`,
        match: (path)=>pathEndsWith(path, 'meetings')
    },
    {
        id: 'tasks',
        labelKey: 'nitro_claw.sidebar.resources.tasks',
        defaultMessage: 'Tasks',
        icon: faListCheck,
        path: `${ROUTE_BASE}/tasks`,
        match: (path)=>pathEndsWith(path, 'tasks')
    }
];
